"use client";

import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
interface StepItem {
  number: string;
  stepTitle: string;
  description: string;
}
const steps: StepItem[] = [{
  number: "01",
  stepTitle: "1. Book",
  description: "Choose your service and appointment online."
}, {
  number: "02",
  stepTitle: "2. Attend Batchwood",
  description: "Come to PhysAnalytica within Batchwood Golf and Sports Centre."
}, {
  number: "03",
  stepTitle: "3. Assessment or Treatment",
  description: "Your appointment is tailored to the service you have booked and your individual needs."
}, {
  number: "04",
  stepTitle: "4. Next Steps",
  description: "You receive clear advice about what, if anything, should happen next."
}];
export default function VisitProcess() {
  return <section id="visitprocess" data-nav="light" className="bg-background text-foreground py-16 sm:py-20 lg:py-24 border-b border-border">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-foreground">
            Your visit to PhysAnalytica
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => <motion.div key={step.number} data-index={i} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.15,
          ease: "easeOut"
        }} whileHover={{
          y: -4
        }} className="h-full">
              <Card className="h-full border border-border bg-card shadow-xs transition-shadow duration-200 hover:shadow-md">
                <CardContent className="flex flex-col h-full justify-between p-6">
                  <div>
                    <div className="flex items-baseline justify-between mb-4 border-b border-border/60 pb-3">
                      <span className="text-2xl font-bold tracking-tight text-primary">
                        {step.number}
                      </span>
                    </div>
                    <h3 className="text-lg font-semibold text-card-foreground mb-2">
                      {step.stepTitle}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>)}
        </div>
      </div>
    </section>;
}